import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

const devForceMotion = typeof window !== 'undefined' && window.location.search.includes('forceMotion=true');
if (devForceMotion && typeof document !== 'undefined') {
  document.body.classList.add('force-motion');
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
